import fetch from "./fetch";
/**
 * 腾讯云上传接口
 */
const upload = {
  // 获取签名
  getUploadSignature(params) {
    return fetch({
      isLoading: true,
      url: "/v1/course/getUploadSignature",
      method: "GET",
      params,
    });
  },
};

export default upload;
